<template>
    {{pregunta}}
</template>


<script>
export default {
  name: 'Fondos',
  props: {
    pregunta: String,
    bg: String
  }
}
</script>

